import React from 'react';

import { type VirtualItem } from '@tanstack/react-virtual';
import classnames from 'classnames';

import { Col, Row } from 'styled-system';

import { type ListColumnType } from '../../VirtualizedList/VirtualizedList.types';

import styles from './ListRow.module.scss';

export type ListRowProps = {
    className?: string;
    columns?: ListColumnType;
    row: { id: string; type?: string };
    virtualRow: VirtualItem;
};

export const ListRow = ({ className, columns, row, virtualRow }: ListRowProps) => {
    const { id } = row;
    const dynamicRowContentId = `dynamic_row_content-${row.id}-${virtualRow.index}`;
    return (
        <>
            <Row className={classnames(styles.row, className)} key={id} wrap={false}>
                {columns?.map(
                    (
                        {
                            key: columnKey,
                            className: columnClassName,
                            component: Component,
                            title,
                            ...rest
                        },
                        columnIndex
                    ) => (
                        <Col
                            {...rest}
                            className={classnames(columnClassName)}
                            key={columnKey ? `${columnKey}-${id}` : columnIndex}
                            title={typeof title === 'string' ? title : ''}
                        >
                            {Component ? (
                                <Component dynamicRowContentId={dynamicRowContentId} row={row} />
                            ) : (
                                <div />
                            )}
                        </Col>
                    )
                )}
            </Row>
            <div id={dynamicRowContentId} />
        </>
    );
};
